export * from './protected-route.module';
export * from './protected-route.component';
